const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_ReportAnalytics":
      return { ...state, Analytics: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
